import React from "react";
import { Layout } from "react-admin";
import { Menu } from "./Menu";
import { PhAppBar } from "./AppBar";

export const PhLayout = (props) => (
  <Layout {...props} menu={Menu} appBar={PhAppBar} />
);
